import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Share, PlusSquare, Download } from 'lucide-react';
import { toast } from 'sonner';
import { useInstallPrompt } from '../hooks/useInstallPrompt';

const IOSSteps = () => (
  <ol className="space-y-3 text-sm text-zinc-700" data-testid="ios-install-steps">
    <li className="flex items-center gap-3 p-3 rounded-xl bg-zinc-50">
      <span className="w-8 h-8 rounded-lg bg-white shadow flex items-center justify-center"><Share className="w-4 h-4 text-blue-500" /></span>
      <span>Toque em <strong>Partilhar</strong> na barra do Safari</span>
    </li>
    <li className="flex items-center gap-3 p-3 rounded-xl bg-zinc-50">
      <span className="w-8 h-8 rounded-lg bg-white shadow flex items-center justify-center"><PlusSquare className="w-4 h-4 text-zinc-700" /></span>
      <span>Escolha <strong>Adicionar ao ecrã principal</strong></span>
    </li>
  </ol>
);

// Renders a trigger via render-prop and handles native prompt / iOS instructions
export const InstallAppAction = ({ children }) => {
  const { available, ios, canPrompt, promptInstall } = useInstallPrompt();
  const [showIOS, setShowIOS] = useState(false);

  if (!available) return null;

  const install = async () => {
    if (canPrompt) {
      if (await promptInstall()) toast.success('HáLubri instalado no seu ecrã principal');
    } else if (ios) {
      setShowIOS(true);
    }
  };

  return (
    <>
      {children(install)}
      <Dialog open={showIOS} onOpenChange={setShowIOS}>
        <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-2xl" data-testid="ios-install-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2"><Download className="w-5 h-5 text-sonangol-red" />Instalar HáLubri</DialogTitle>
            <DialogDescription>Adicione a app ao ecrã principal do seu iPhone em 2 passos.</DialogDescription>
          </DialogHeader>
          <IOSSteps />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InstallAppAction;
